var _this = this;

var TOOLTIP_BORDER_STYLE = "1px solid ";
var TOP_OFFSET = 33;
var LEFT_OFFSET = 10;
var DEFAULT_OFFSET = 0;

var areaTooltip = function () {

    // Get marker line element corresponding to the marker
    var getMarkerLine = function getMarkerLine() {
        var splittedMarkerId = d3.select(this).attr("id").split('-');
        var seriesName = splittedMarkerId[1] && splittedMarkerId[1].toLowerCase();
        seriesName = seriesName && seriesName.length ? seriesName : "--" + splittedMarkerId[3];
        return d3.select(this.closest("g")).select("[id = 'line-" + seriesName + "']");
    };

    var onMouseOver = function onMouseOver(containerId) {
        var labelValue = d3.select(this).attr("label");
        if (labelValue.length) {
            var e = d3.event;
            var tipText = "<p>" + labelValue + "</p>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            if ($("#toolTip")[0]) {
                $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
            }

            d3.select(this).style("opacity", 1);
            getMarkerLine.call(this).style("opacity", 1);
        }
    };

    var onMouseOut = function onMouseOut() {
        var e = d3.event;

        // Remove tooltip
        d3.select("#toolTip").remove();

        // Hide markers
        d3.select(e.currentTarget.closest('g')).selectAll('.dot').style('opacity', 0);

        // Hide markerLines
        d3.select(e.currentTarget.closest('g')).selectAll("[seriesidentifier ^= 'markerline']").style('opacity', 0);
    };

    var onMouseMove = function onMouseMove(containerId) {
        // Remove tooltip, hide markers, hide marker lines
        onMouseOut();

        var e = d3.event;
        var touchList = d3.touches(this);
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");
        if (!tip.length) {
            var labelValue = d3.select(this).attr("label");
            if (labelValue.length) {
                var tipText = "<p>" + labelValue + "</p>";
                toolTipHelper.showTooltip(tipText, e, "#" + containerId);
                $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
                d3.select(this).style("opacity", 1);
                getMarkerLine.call(this).style("opacity", 1);
            }
            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove
    };
}();

var columnTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var tipText = "<p>" + $(this).attr("label") + "</P>";

        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");

        if (!tip.length) {
            var tipText = "<p>" + $(this).attr("label") + "</P>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var lineTooltip = function () {

    // Get marker line element corresponding to the marker
    var getMarkerLine = function getMarkerLine() {
        var splittedMarkerId = d3.select(this).attr("id").split('-');
        var seriesName = splittedMarkerId[1] && splittedMarkerId[1].toLowerCase();
        seriesName = seriesName && seriesName.length ? seriesName : "--" + splittedMarkerId[3];
        return d3.select(this.closest("g")).select("[id = 'line-" + seriesName + "']");
    };

    var onMouseOver = function onMouseOver(containerId) {
        var labelValue = d3.select(this).attr("label");
        if (labelValue.length) {
            var e = d3.event;
            var tipText = "<p>" + labelValue + "</p>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            d3.select(this).style("opacity", 1);
            getMarkerLine.call(this).style("opacity", 1);
            if ($("#toolTip")[0]) {
                $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
            }
        }
    };

    var onMouseOut = function onMouseOut(seriesConfig) {
        var e = d3.event;

        // Remove tooltip
        $("#toolTip").remove();

        // Hide markers
        var identifierList = d3.select(e.currentTarget.closest('g')).selectAll('.dot');

        for (var identifierIndex = 0; identifierIndex < identifierList[0].length; identifierIndex++) {
            var identifierName = $(identifierList[0][identifierIndex]).attr('seriesidentifier');
            for (var seriesIndex = 0; seriesIndex < seriesConfig.length; seriesIndex++) {
                if (seriesConfig[seriesIndex].SeriesName === identifierName && !seriesConfig[seriesIndex].ShowLineMarkers) {
                    $(identifierList[0][identifierIndex]).css('opacity', 0);
                    break;
                }
            }
        }

        // Hide markerLines
        d3.select(e.currentTarget.parentNode).selectAll("[seriesidentifier ^= 'markerline']").style('opacity', 0);
    };

    var onMouseMove = function onMouseMove(containerId, seriesConfig) {
        // Remove tooltip, hide markers, hide marker lines
        onMouseOut(seriesConfig);

        var e = d3.event;
        var touchList = d3.touches(this);
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");
        if (tip == null || tip.length == 0) {
            var labelValue = d3.select(this).attr("label");
            if (labelValue.length) {
                var tipText = "<p>" + labelValue + "</p>";
                toolTipHelper.showTooltip(tipText, e, "#" + containerId);
                d3.select(this).style("opacity", 1);
                getMarkerLine.call(this).style("opacity", 1);
                $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
            }
            return;
        }
        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = 0;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = 0;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - 20,
            left: offsetX + 10
        });
    };
    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove
    };
}();

var tableTooltip = function () {
    var onMouseOver = function onMouseOver(e) {
        var tipText = "<p>" + $(this).attr("label") + "</P>";
        var widgetContainer = $(this).parents(".widget-container");
        if (widgetContainer == null) return;

        toolTipHelper.showTooltip(tipText, e, "#" + widgetContainer.attr("id"));
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(e) {
        if (typeof e.targetTouches !== "undefined" && e.targetTouches.length) {
            var touch = e.targetTouches[0];
            e.pageX = touch.pageX;
            e.pageY = touch.pageY;
        }
        var x = e.clientX;
        var y = e.clientY;

        var tip = $("#toolTip");

        if (tip == null || tip.length == 0) {
            var tipText = "<p>" + $(this).attr("label") + "</P>";

            var widgetContainer = $(this).parents(".widget-container");
            if (widgetContainer == null) return;
            toolTipHelper.showTooltip(tipText, e, "#" + widgetContainer.attr("id"));

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var labelTooltip = function () {
    var onMouseOver = function onMouseOver(e) {
        var tipText = "<p>" + $(this).attr("label") + "</P>";
        var widgetContainer = $(this).parents(".widget-container");
        if (widgetContainer == null) return;

        toolTipHelper.showTooltip(tipText, e, "#" + widgetContainer.attr("id"));
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(e) {
        if (typeof e.targetTouches !== "undefined" && e.targetTouches.length) {
            var touch = e.targetTouches[0];
            e.pageX = touch.pageX;
            e.pageY = touch.pageY;
        }
        var x = e.clientX;
        var y = e.clientY;

        var tip = $("#toolTip");

        if (tip == null || tip.length == 0) {
            var tipText = "<p>" + $(this).attr("label") + "</P>";

            var widgetContainer = $(this).parents(".widget-container");
            if (widgetContainer == null) return;
            toolTipHelper.showTooltip(tipText, e, "#" + widgetContainer.attr("id"));

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var pieTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var label = $(this).attr("label");
        if (d3.select(this).classed("deployed")) label += " (DEPLOYED)";
        if (d3.select(this).classed("supported")) label += " (SUPPORTED)";
        var tipText = "<p>" + label + "</P>";
        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + $(this).attr("fill");
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");

        if (!tip.length) {
            var tipText = "<p>" + $(this).attr("label") + "</P>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + $(this).attr("fill");

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var bubbleTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var tipText = "<p>" + d3.select(e.target).attr("label") + "</P>";

        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.getElementsByTagName('circle')[0].style.fill;
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");

        if (!tip.length) {
            var tipText = "<p>" + d3.select(e.target).attr("label") + "</P>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.getElementsByTagName('circle')[0].style.fill;

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var worldMapTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var label = $(this).attr("label");
        if (d3.select(this).classed("deployed")) label += " (DEPLOYED)";
        if (d3.select(this).classed("supported")) label += " (SUPPORTED)";
        var tipText = "<p>" + label + "</P>";
        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + $(this)[0].style.fill;
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");

        if (!tip.length) {
            var tipText = "<p>" + $(this).attr("label") + "</P>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + $(this)[0].style.fill;

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var usMapTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var label = $(this).attr("label");
        if (label == null || label == undefined) return;
        var tipText = "<p>" + label + "</P>";
        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + $(this)[0].style.fill;
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        var x = void 0,
            y = void 0;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        if (e.clientX == undefined) {
            x = e.pageX - $(this).offset().left;
            y = e.pageY - $(this).offset().top;
        } else {
            x = e.clientX;
            y = e.clientY;
        };

        var tip = $("#toolTip");

        if (!tip.length) {
            var label = $(this).attr("label");

            if (label == null || label == undefined) return;

            var tipText = "<p>" + label + "</P>";
            toolTipHelper.showTooltip(tipText, e, "#" + containerId);
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + $(this)[0].style.fill;
            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };
    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var toolTipHelper = function () {
    var showTooltip = function showTooltip(data, e, parent) {
        if (data == null || data.indexOf("undefined") > -1) return;

        if (data == "") {
            $("#toolTip").remove();
            return;
        }

        if (typeof e.targetTouches !== "undefined" && e.targetTouches.length) {
            var touch = e.targetTouches[0];
            e.pageX = touch.pageX;
            e.pageY = touch.pageY;
        }

        var x = void 0,
            y = void 0;
        if (e.clientX == undefined) {
            x = e.pageX - $(_this).offset().left;
            y = e.pageY - $(_this).offset().top;
        } else {
            x = e.clientX;
            y = e.clientY;
        };

        $("#toolTip").remove();

        var tip = $("<span>");
        tip.attr("id", "toolTip");
        tip.attr("class", "tooltip");
        tip.css("display", "none");
        tip.attr("parentId", parent);

        var parentOffset = { top: 0, left: 0 };
        var tooltipContainerId = "body";

        var tipText = data;

        tip.html(tipText);

        $(tooltipContainerId).append(tip);
        tip.animate({
            opacity: "show"
        }, {
            duration: 300
        });

        $("#toolTip").append($("<span id='tooltipArrow'></span>"));
        $("#tooltipArrow").addClass("arrowTip");

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var notchHeight = tipHeight * 20 / 100;
        $("#tooltipArrow").css({ "height": notchHeight, "width": notchHeight });

        x = e.clientX;
        y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        var tooltipStyle = $("#toolTip").children()[1].style;

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
            $("#tooltipArrow").css({ "left": tipWidth + 3 });
            tooltipStyle.transform = "rotate(-135deg)";
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        $("#tooltipArrow").css({ "top": TOP_OFFSET });

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        showTooltip: showTooltip
    };
}();

var sankeyTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var tipText = "<p>" + $(this).attr("label") + "</P>";
        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($(this).attr("class") === "link dataviz" && $("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.stroke;
        } else if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        var x = void 0,
            y = void 0;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");

        if (!tip.length) {
            var tipText = "<p>" + $(this).attr("label") + "</P>";
            showTooltip(tipText, e, "#" + containerId);
            if ($(this).attr("class") === "link dataviz") {
                $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.stroke;
            } else {
                $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
            }
            return;
        }

        x = e.clientX;
        y = e.clientY;

        var parentOffset = { top: 0, left: 0 };

        tip.offset({
            top: y + parentOffset.top - 33,
            left: x + 20 + parentOffset.left
        });

        setTooltipAutoHide();
    };
    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

var twobytwoTooltip = function () {
    var onMouseOver = function onMouseOver(containerId) {
        var e = d3.event;
        var tipText = "<p>" + d3.select(e.target).attr("label") + "</P>";
        toolTipHelper.showTooltip(tipText, e, "#" + containerId);
        if ($("#toolTip")[0]) {
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;
        }
    };

    var onMouseOut = function onMouseOut() {
        $("#toolTip").remove();
    };

    var onTouchMove = function onTouchMove() {
        $("#toolTip").remove();
    };

    var onMouseMove = function onMouseMove(containerId) {
        var touchList = d3.touches(this);
        var e = d3.event;
        if (touchList.length) {
            var touch = touchList[0];
            e.pageX = touch[0];
            e.pageY = touch[1];
        }

        var tip = $("#toolTip");

        if (!tip.length) {
            var tipText = "<p>" + d3.select(e.target).attr("label") + "</P>";
            showTooltip(tipText, e, "#" + containerId);
            $("#toolTip")[0].style.border = TOOLTIP_BORDER_STYLE + this.style.fill;

            return;
        }

        var tipHeight = tip.height();
        var tipWidth = tip.width();

        var x = e.clientX;
        var y = e.clientY;

        var offsetY = y;
        var offsetX = x;
        var windowHeight = $(window).height();
        var windowWidth = $(window).width();

        if (windowHeight < y + tipHeight) offsetY = y - (y + tipHeight - windowHeight);

        if (tipHeight >= windowHeight) {
            offsetY = DEFAULT_OFFSET;
        }
        if (x + tipWidth >= windowWidth) {
            offsetX = DEFAULT_OFFSET;
        }

        if (windowWidth < x + tipWidth) offsetX = x - tipWidth - 30;

        tip.offset({
            top: offsetY - TOP_OFFSET,
            left: offsetX + LEFT_OFFSET
        });
    };

    return {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onTouchMove: onTouchMove,
        onMouseMove: onMouseMove
    };
}();

export { columnTooltip, areaTooltip, lineTooltip, tableTooltip, labelTooltip, pieTooltip, bubbleTooltip, worldMapTooltip, usMapTooltip, sankeyTooltip, twobytwoTooltip };